import jwtEncode from 'jwt-encode'

// 从环境变量获取密钥
const ACCESS_KEY = import.meta.env.VITE_ACCESS_KEY
const SECRET_KEY = import.meta.env.VITE_SECRET_KEY

export function generateToken() {
  const payload = {
    iss: ACCESS_KEY,
    iat: Math.floor(Date.now() / 1000),
    exp: Math.floor(Date.now() / 1000) + (2 * 60 * 60) // 2 hours
  }

  const header = {
    alg: 'HS256',
    typ: 'JWT'
  }

  return jwtEncode(payload, SECRET_KEY, header)
} 